// src/components/AddedToBagToast.js
import React from "react";
import { useCart } from "../context/CartContext";

function AddedToBagToast() {
  const { addedToast, lang } = useCart();

  if (!addedToast) return null;

  const message =
    lang === "EN"
      ? `“${addedToast.nameEN}” added to your bag`
      : `“${addedToast.nameAR}” أُضيفت إلى سلة المشتريات`;

  return (
    <div
      className="
        fixed
        top-[90px]              /* moved higher for a premium look */
        left-1/2 
        -translate-x-1/2
        z-[99999]

        px-5 py-3.5
        rounded-full
        text-[13px] md:text-sm
        font-medium
        text-white

        bg-[rgba(20,20,20,0.85)]
        shadow-[0_8px_30px_rgba(0,0,0,0.35)]
        backdrop-blur-[12px]

        flex items-center gap-2

        animate-toastSlideFade
      "
    >
      {/* ICON */}
      <span className="text-lg">✔️</span>

      {message}

      {/* SMALL PULSE DOT */}
      <span className="w-2 h-2 rounded-full bg-white animate-ping"></span>
    </div>
  );
}

export default AddedToBagToast;
